import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { List, Map, fromJS } from 'immutable';
import { getFormValues, isValid, reset } from 'redux-form';

import * as tagActions from 'modules/tag';
import * as declareActions from 'modules/declare';
import * as currentStatusActions from 'modules/currentStatus';
import * as validFunc from 'libs/validation';

import { Icon } from 'semantic-ui-react';

import { DeclareDetail } from 'components';

class CtDeclareDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isClicked: false,
      errorMessage: ''
    };

    this.onPutDeclare = this.onPutDeclare.bind(this);
    this.onDeleteDeclare = this.onDeleteDeclare.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectDeclareTargetNo, currentPath } = this.props;

    if (selectDeclareTargetNo !== prevProps.selectDeclareTargetNo) {
      if (currentPath === '/main/declaration/exam') {
        this.onGetDeclareDetail();
      }
    }
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 상세보기 보이기/숨기기
  onToggleDetailView = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.onToggleDetailView();
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formTagTargetAdd');
    ReduxFormReset('formTagTargetDelete');
    this.setState({ errorMessage: '' });

    CurrentStatusActions.changeTargetTagModal({
      tagNoArray: []
    });

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 아이콘을 통한 스크롤 이동 처리
  onMoveScroll = id => {
    this.scroll.scrollTop(this[id].offsetTop - 15);
  };

  // 스크롤 ref 등록
  onRefRegister = (key, refObject) => {
    if (!!refObject) {
      this[key] = refObject;
    }
  };

  // 신고 상세 목록 조회
  onGetDeclareDetail = async () => {
    const { examNoArray, DeclareActions, selectDeclareTargetNo } = this.props;

    if (!!selectDeclareTargetNo) {
      try {
        const params = {
          targetNo: selectDeclareTargetNo
        };

        if (examNoArray.get(0) !== 'all') {
          params['examNoArray'] = examNoArray;
        }

        await DeclareActions.getDeclareDetail(params);
      } catch (e) {
        console.log(e);
      }
    }
  };

  // 신고 상세 삭제 모달
  onToggleModalDeclare = (declareNo, type) => {
    const { CurrentStatusActions } = this.props;

    if (!!declareNo) {
      // 선택한 신고 번호 저장
      CurrentStatusActions.selectDeclareNo({ declareNo });

      if (type === 'put') {
        this.onToggleModal('declarePut');
      } else if (type === 'delete') {
        this.onToggleModal('declareDelete');
      }
    }
  };

  // 신고 상세 수정
  onPutDeclare = async declareNo => {
    setTimeout(async () => {
      try {
        const { DeclareActions, selectDeclareNo, declareDetail, formDeclarePut, selectDeclareTargetNo } = this.props;

        if (!!formDeclarePut) {
          let isEdit = false;
          const beforeData = declareDetail.get(String(selectDeclareNo));
          const params = {
            declareNo: declareNo
          };

          if (formDeclarePut.subject !== '' && formDeclarePut.content !== '') {
            // 제목 수정
            if (formDeclarePut.subject !== beforeData.subject) {
              isEdit = true;
              params.subject = formDeclarePut.subject;
            }

            // 내용 수정
            if (formDeclarePut.content !== beforeData.content) {
              isEdit = true;
              params.content = formDeclarePut.content;
            }
          }

          if (isEdit) {
            await DeclareActions.putDeclare(params);

            this.onToggleModal('');
          } else {
            console.log('수정 사항 없음');
          }
        } else {
          //
        }
      } catch (e) {
        console.log(e);
      }
    }, 100);
  };

  // 신고 상세 정보 삭제
  onDeleteDeclare = async declareNo => {
    const { DeclareActions, selectDeclareTargetNo } = this.props;

    try {
      await DeclareActions.deleteDeclare({ declareNo: declareNo, targetNo: selectDeclareTargetNo });

      this.onToggleModal('');
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const {
      onToggleSnackbar,
      onToggleModal,
      onToggleDetailView,
      onMoveScroll,
      onRefRegister,
      // 수정
      onPutDeclare,
      onDeleteDeclare,
      // 삭제
      onToggleModalDeclare
    } = this;
    const {
      selectDeclareTargetNo,
      selectDeclareNo,
      declareDataByTargetNo,
      isSnackbar,
      isModal,
      declareDetail,
      declareDetailOrdering,
      formDeclarePut,
      currentPath
    } = this.props;


    const isMail = currentPath === '/main/declaration/mail';
    let declareNoArray = isMail ? [(declareDetailOrdering.find(value => value === selectDeclareTargetNo))] : declareDetailOrdering;

    return (
      <DeclareDetail
        selectDeclareTargetNo={selectDeclareTargetNo}
        selectDeclareNo={selectDeclareNo}
        declareDataByTargetNo={declareDataByTargetNo}
        isSnackbar={isSnackbar}
        onToggleModal={onToggleModal}
        isModal={isModal}
        // function
        onToggleSnackbar={onToggleSnackbar}
        onToggleDetailView={onToggleDetailView}
        onMoveScroll={onMoveScroll}
        onRefRegister={onRefRegister}
        // 상세 리스트
        declareDetail={declareDetail}
        declareDetailOrdering={declareNoArray}
        // 상세 수정, 삭제 모달
        onToggleModalDeclare={onToggleModalDeclare}
        // 상세 수정
        onPutDeclare={onPutDeclare}
        formDeclarePut={formDeclarePut}
        // 상세 삭제
        onDeleteDeclare={onDeleteDeclare}
        currentPath={currentPath}
      />
    );
  }
}

const mapStateToProps = state => ({
  isEditSubmit: state.currentStatus.get('isEditSubmit'),
  isSnackbar: state.currentStatus.get('isSnackbar'),
  isModal: state.currentStatus.get('isModal'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  currentPath: state.currentStatus.getIn(['path', 'current']),
  examNoArray: state.declare.get('examNoArray'),
  totalDeclare: state.declare.get('totalDeclare'),
  selectDeclareTargetNo: state.currentStatus.getIn(['declare', 'selectDeclareTargetNo']),
  selectDeclareNo: state.currentStatus.getIn(['declare', 'selectDeclareNo']),
  declareDetailOrdering: state.declare.get('declareDetailOrdering'),
  declareDetail: state.declare.get('declareDetail'),
  declareDataByTargetNo: state.declare.get('declareDataByTargetNo'),
  formDeclarePut: getFormValues('formDeclarePut')(state)
});

const mapDispatchToProps = dispatch => ({
  TagActions: bindActionCreators(tagActions, dispatch),
  DeclareActions: bindActionCreators(declareActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtDeclareDetail));



// WEBPACK FOOTER //
// ./src/script/containers/declare/CtDeclareDetail.js